import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { xs_languageCode } from '..';
import { AppContext } from '../App';
import { isSeoSettingsNoFollow } from '../data/seo/seoUtils';
import { useAbsolutePath } from '../data/seo/seoRouteUtils';
import { splitHandicap } from '../data/splitHandicap';
import { classIf } from '../data/utils/classIf';
import { getConfiguration } from '../data/utils/configuration';
import { parseHandicap } from '../data/utils/parseHandicap';
import { LiveMatchContext } from '../live/match/LiveMatchDataFetcher';
import { MatchContext } from '../prematch/match/MatchDataFetcher';
import { PrematchContext } from '../prematch/Prematch';
import { useExpandedView } from './ExpandedViewProvider';
import { TournamentContext } from '../prematch/tournament/TournamentDataFetcher';
import { BetsExpandCollapseContext } from './BetsExpandCollapseContext';
import CashoutLabel from './CashoutLabel';
import { ASIAN_HANDICAP } from '../data/constants';
import { BetslipContext } from '../data/betslip/BetslipConf';

function groupOdds(match, bet) {
    const oddsByDesc = new Map();
    let sortDescs = false;
    bet.odds.forEach(o => {
        const result = splitHandicap(o.betData.handicap, o.betData.tipoHandicap, null, '', xs_languageCode);
        let desc = null, parsedHandicap = null;
        if (o.betData.dia != null) {
            desc = o.betData.dia;
            parsedHandicap = result.info2;
            sortDescs = true;
        } else {
           desc = result.info2;
           if (desc === 1) {
               desc = match.team1;
           } else if (desc === 2) {
               desc = match.team2;
           }
           parsedHandicap = result.info1;
        }
        if (!oddsByDesc.has(desc)) {
            oddsByDesc.set(desc, []);
        }
        oddsByDesc.get(desc).push({
            ...o,
            parsedHandicap
        });
    });

    const descs = Array.from(oddsByDesc.keys());
    if (sortDescs) {
        descs.sort();
    }

    return [descs, oddsByDesc];
}

function Odd(props) {
    const conf = getConfiguration();
    
    const betslipContext = React.useContext(BetslipContext);

    const betData = props.betData;
    const betId = betData.cs != null ? props.betData.cs : props.betData.id;

    function onClick(e) {
        e.preventDefault();
        e.stopPropagation();
        let hcp = props.betData.handicap;
        if (conf.nas && ASIAN_HANDICAP.includes(props.betData.id) && props.id === 2) {
            hcp *= -1;
        }
    	let betDesc = props.betData.desc;
        let oddDesc = props.desc;
        if (props.betData.hideHandicap === true) {
            betDesc = props.betData.aggDesc;
            oddDesc = `${betData.desc} ${props.desc}`;
        } else if (props.betData.handicap !== 0) {
            let draws = null;
            if (props.betData.tipoHandicap === 7) {
                draws = props.betData.eqs;
            }
            betDesc = parseHandicap(props.betData.desc, hcp, props.betData.tipoHandicap, draws, props.betData.dia);
        }
        const timestamp = props.matchData.timestampDB? props.matchData.timestampDB : props.matchData.timestamp;
    	props.value != null && 
        betslipContext.toggleSelectionBetslip(props.matchData.pal,
                                                props.matchData.avv,
                                                props.matchData.alias,
                                                props.matchData.desc,
                                                props.betData.isLive,
                                                betId,
                                                props.betData.handicap,
                                                betDesc,
                                                props.id,
                                                oddDesc,
                                                props.rawValue,
                                                props.betData.legabile,
                                                props.matchData.sportDesc,
                                                props.matchData.tournamentDesc,
                                                timestamp,
                                                props.matchData.sportRef,
                                                props.matchData.tournamentRef,
                                                props.betData.ming,
                                                props.betData.maxg);
    }

    const selected = betslipContext.isDrawSelected(props.matchData.pal, props.matchData.avv, props.betData.id, props.betData.handicap, props.id);
    let classes = '';
    if (selected) {
        classes += ' bet-selected';
    }
    if (props.betData.pClass != null) {
        classes += ' ' + props.betData.pClass;
    }

    return (
        <div className={"esito" + classes} onClick={onClick}>
            <span className="nome-esito text-small">{props.desc} ({props.parsedHandicap})</span>
            <hr />
            {props.value != null ?
                <span className="quota-esito text-small">{props.value}</span>
                :
                <span className="quota-esito text-small">&#128274;</span>
            }
        </div>
    );
}

function Odds(props) {
    const odds = props.odds.sort((a, b) => a.parsedHandicap - b.parsedHandicap);

    return (
        <div className={"esiti-container grid-columns-" + (odds.length < 3 ? odds.length : '3')}>
            {odds.filter(o => o.value != null).map(o =>
                <Odd key={o.uniqueId} {...o} />
            )}
        </div>
    );
}

function OddsToggle(props) {
    const expandedView = useExpandedView();
    const [toggled, setToggled] = useState(expandedView?.toggled ?? false);
    
    const toggle = useCallback(() => setToggled(prev => !prev), []);

    useEffect(() => {
        if (expandedView && expandedView.toggled !== toggled) {
            setToggled(prev => !prev);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [expandedView?.toggled]);

    return (
        <>
            <div className="small-navbar mt-1 mx-1 px-2" onClick={toggle}>
                <span className="mr-auto">{props.desc}</span>
                {props.statsInfo &&
                    <span className="xs_statsInfoContainer">{props.statsInfo}</span>
                }
                {toggled ?
                    <i className="fa fa-angle-up" />
                    :
                    <i className="fa fa-angle-down" />
                }
            </div>
            {toggled && props.children}
        </>
    );
}

export default function GroupedView(props) {
    const appContext = React.useContext(AppContext);
    const prematchContext = useContext(PrematchContext);
    const tournamentContext = useContext(TournamentContext)
    const match = props.match;
    const bet = props.bet;

    function handleClickHref(e){
        //e.preventDefault();
        if (window.blockHistoryChanges()) {
            e.preventDefault();
            if (tournamentContext != null) {
                prematchContext.openMatchFromTournament({
                    ...tournamentContext.data,
                    liveMatches: tournamentContext.liveMatches
                }, match);
            } else {
                prematchContext.openMatch(match);
            }
        }else{
            appContext.setHandleOpenFromPath(true);
            if (tournamentContext != null) {
                prematchContext.openMatchFromTournament({
                    ...tournamentContext.data,
                    liveMatches: tournamentContext.liveMatches
                }, match);
            } else {
                prematchContext.openMatch(match);
            }
        }
    }

    //const absoluteMatchPath = useAbsolutePath(match.urlPath,null,match.urlPathSeo,false);
    const relativeMatchPath = useAbsolutePath(match.urlPath,null,match.urlPathSeo,true);
    const noFollow = isSeoSettingsNoFollow(match.urlPathSeoSettings);

    const [descs, oddsByDesc] = groupOdds(match, bet);

    return (
        <>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <Link to={encodeURI(relativeMatchPath) } className="info-avvenimento" onClick={handleClickHref.bind(this)} {...(noFollow ? {rel: 'nofollow'}:{})} >
                <div className="nome-avvenimento">
                    <span className="text-small">{match.team1}</span>
                    <span className="text-small">{match.team2}</span>
                </div>
                <span className="ora-avvenimento text-small push-right">{match.time}</span>
                <span className="ora-avvenimento text-small">(+{match.plus})</span>
                <div className="arrow-container arrow-container-small">
                    <span className="arrow arrow-right"></span>
                </div>
            </Link>
            {descs.map(desc => {
                const odds = oddsByDesc.get(desc);
                return (
                    <OddsToggle key={desc} desc={desc} statsInfo={odds[0]?.betData?.statsInfo ?? null}>
                        <Odds odds={odds} />
                    </OddsToggle>
                );
            })}
        </>
    );
}

export function GroupedViewBet(props) {
    const betsExpandCollapseContext = React.useContext(BetsExpandCollapseContext);
    const matchContext = React.useContext(MatchContext);
    const liveMatchContext = React.useContext(LiveMatchContext);
    const context = matchContext || liveMatchContext;
    const betId = `${props.id}_${props.handicap}`;
    const [expanded, setExpanded] = useState(true);

    function handleClick() {
        if (context && context.favoritesSelected) {
            setExpanded(!expanded);
        } else {
            betsExpandCollapseContext && betsExpandCollapseContext.toggleBetCollapsedById(props.toggleCollapseId)
        }
    }

    function toggleFavorite(e) {
        e.stopPropagation();
        context.toggleFavorite(context.match.sportRef, betId);
    }

    useEffect(() => {
        if (!context || (context && !context.favoritesSelected)) {
            betsExpandCollapseContext && betsExpandCollapseContext.toggleBetCollapsedById(props.toggleCollapseId, !props.expanded);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.toggleCollapseId]);

    const show = (context && context.favoritesSelected) ? expanded : props.expanded;

    const match = props.match;
    const bet = props.bet;
    const [descs, oddsByDesc] = groupOdds(match, bet);
    
    return (
        <li className={"list-element-quota" + classIf(show, 'show')}>
            <div className="list-element" onClick={handleClick}>
                <div className="list-element-text">
                    {bet.desc}
                    <CashoutLabel bet={bet} />
                </div>
                {context &&
                    <div className="pin-toggle mr-4" onClick={toggleFavorite}>
                        <i className={"fas fa-thumbtack rotate-45" + classIf(context.isMarketFavorite(context.match.sportRef, betId), 'selected')}></i>
                    </div>
                }
                <span className="arrow arrow-expand"></span>
            </div>
            {show &&
                <>
                    {descs.map(desc => {
                        const odds = oddsByDesc.get(desc);
                        return (
                            <OddsToggle key={desc} desc={desc} statsInfo={odds[0]?.betData?.statsInfo ?? null}>
                                <Odds odds={odds} />
                            </OddsToggle>
                        );
                    })}
                </>
            }
        </li>
    );
}
